import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { PopupComponent } from './popup.component';
import { PopupSettings } from 'src/app/model/popup.model';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogRef: MatDialogRef<PopupComponent> | undefined;
  isdisableClose = true;

  constructor(private dialog: MatDialog) {}
  public $dialog(settings: PopupSettings): Observable<any> {
    this.isdisableClose = settings.disableClose ? true : false;
    this.dialogRef = this.dialog.open(PopupComponent, {
      width: settings.width || ' 40%',
      disableClose: this.isdisableClose,
      panelClass: 'cmn-confirm',
      height: settings.height,
      maxHeight: '600px',
      maxWidth: settings.width,
      data: settings.data,
    });
    this.dialogRef.componentInstance.title = settings.headerText;
    this.dialogRef.componentInstance.message = settings.message;
    this.dialogRef.componentInstance.innerMsg = settings.subMessage;
    this.dialogRef.componentInstance.popupSettings = settings;

    return this.dialogRef.afterClosed();
  }
}
